<lib-base-card [isLoading]="isLoading">
  <div class="card-content">
    <lib-calendar-appointment-details
      [mode]="mode"
      [businessObject]="businessObject"
      [appointment]="appointment"
      [staff]="staff"
    >
      <ng-container *ngIf="!disableCheckin" checkin-content>
        <ng-container *ngIf="isCheckedIn">
          <lib-spacer></lib-spacer>
          <lib-success-check-animation-icon></lib-success-check-animation-icon>
        </ng-container>

        <ng-container
          *ngIf="
            isProVersion && isCheckInTime && !isEditActionForbiddenForStaffApp()
          "
        >
          <lib-spacer></lib-spacer>
          <lib-circle-animation-button
            [buttonLabel]="
              'lib_calendar.appointment-details-card.buttons.checkin'
                | translate
            "
            (clicked)="checkinClickHandler()"
          ></lib-circle-animation-button>
        </ng-container>
      </ng-container>
    </lib-calendar-appointment-details>

    <ng-container *ngIf="shouldDisplayAdvancedInfo() || isCancelled">
      <lib-spacer></lib-spacer>
      <lib-info-box>
        @if (shouldDisplayAdvancedInfo()) {
        <span
          >{{
            'lib_calendar.appointment-details-card.text.status' | translate
          }}: {{ appointment?.status | appointmentStatusFormatter }}</span
        >
        } @else {
        <span>
          {{
            (appointment?.status === APPOINTMENT_STATUS.CUSTOMER_CANCELLED
              ? 'lib_calendar.appointment-details-card.text.appointment-canceled-by-you'
              : 'lib_calendar.appointment-details-card.text.appointment-canceled-by-salon'
            ) | translate
          }}!</span
        >
        }
      </lib-info-box>
    </ng-container>
  </div>
</lib-base-card>
